
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import ComponentAbstract from '../core/components/ComponentAbstract';
import DisplayUtils from 'frontools/utils/DisplayUtils';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import Context from 'frontools/core/Context';


export class Level extends ComponentAbstract {

    private _level                      : PIXI.Container                = new PIXI.Container();
    private _context                    : Context                       = Context.getInstance();
    private _bodyPart                   : PIXI.extras.AnimatedSprite;
    private _stage                      : PIXI.Container;
    private _renderer                   : PIXI.SystemRenderer;
    private _progress                   : number                        = 1;
    private _progressTop                : number                        = 1;
    private _justClick                  : boolean                        = false;
    private _destroyInterval            : any ;               
    private _screenWidth                : number;
    private _screenHeight               : number;
    private _fireSoundCount             : number                        =0;

    public static CLICK                 : string                        = 'click';
    public static TAP                   : string                        = 'tap';
    public static COMPLETE              : string                        = 'complete';
    public static MOUSE_UP_OUTSIDE      : string                        = 'mouseupoutside';
    public static HIT                   : string                        = 'hit';
    public static RETRACT               : string                        = 'retract';

    constructor(private _config: ILevelConfig) {
        super();
        
        this._renderer = GameAbstract.instance.renderer;
        this._stage = GameAbstract.instance.stage;
        
        this._bodyPart = this.getSpriteFromImg(this._config.character);
        this._bodyPart.pivot.x = this._bodyPart.width / 2;
        this._bodyPart.pivot.y = this._bodyPart.height / 2;
        if (window.devicePixelRatio > 1) {
            this._bodyPart.scale.x = this._config.scaleX*2;
            this._bodyPart.scale.y = 2;
        } else {
            this._bodyPart.scale.x = this._config.scaleX;
            this._bodyPart.scale.y = 1;
        }

        this._level.addChild(this._bodyPart);


        this._stage.addChildAt(this._level, 0);

        this.destroySkin();
    };

    public getSpriteFromImg(name: string) {
        var frames = [],
            frameCount = this._config.framesCount;

        for (var i = 1, l = frameCount; i <= l ; i++) {
            frames.push(Assets.getRessource(name + i));
        }

        // create an AnimatedSprite (brings back memories from the days of Flash, right ?)
        return new PIXI.extras.AnimatedSprite(frames);
    };


    public repairSkin(e){
        
        
        // update progress percent (5 by 5 percent for exemple)
        if(e.type == 'tap'){
            this._progress += this._config.progressTapStep;
        } else {
            this._progress += this._config.progressClickStep;

        }

        // update progresstop if needed
        if(this._progress > this._progressTop){
            this._progressTop = this._progress;
        };
        
        //animate bodypart
        this._bodyPart.gotoAndStop(Math.ceil(this._bodyPart.totalFrames*this._progress/100));
        this._justClick = true;
        setTimeout(function(){this._justClick = false;}.bind(this), 50);

        //check for completion
        if(this._progress >= 100) {
            //console.log('fin niveau');
            this.dispatch({type: Level.COMPLETE});

        }


        
    }

    public destroySkin(){

        this._destroyInterval = setInterval(function(){
            
            // update progress
            if(this._progress > 5){
                this._progress -= 5;

                // animate progress
                if(this._justClick == true){
                    setTimeout(function(){this._bodyPart.gotoAndStop(Math.ceil(this._bodyPart.totalFrames*this._progress/100));}.bind(this), 50);
                    
                }
                this._bodyPart.gotoAndStop(Math.ceil(this._bodyPart.totalFrames*this._progress/100));
            }
            this.dispatch({type: Level.RETRACT});
            
        }.bind(this), this._config.speed);
    }

    public cheerSounds(){
        this._fireSoundCount +=1;
        if (this._fireSoundCount == 10){
            this._fireSoundCount = 0;
            return true;

        } else {
            return false;
        }
    }
    

    public get container(): PIXI.Container {
        return this._level;
    };

    public get progress() {
        return this._progress;
        
    };


    public get config(): ILevelConfig {
        return this._config;
    };


    public enable() {
        this._level.interactiveChildren = true;
    };


    public disable() {
        this._level.interactiveChildren = false;
    };



    /*
     * destroy - destroy this instance
     * 
     */
    public destroy() {
        super.destroy();
        
        this._stage.removeChild(this._level);
        this._level.destroy();
        window.clearInterval(this._destroyInterval);

    };


    /*
     * _resize - handle resize
     * 
     */
    protected _resize(e) {
        super._resize(e);
        this._screenHeight = this._renderer.screen.height;
        this._screenWidth = this._renderer.screen.width;
        this._bodyPart.x = this._screenWidth/2;
        this._bodyPart.y = this._screenHeight/2;
       /* if(this._config.scaleX == -1 && this._config.character == "gameplayBras"){
            this._bodyPart.x = this._bodyPart.width/2;
            this._bodyPart.y = this._bodyPart.height/2;
        } else if(this._config.scaleX == 1 && this._config.character == "gameplayBras") {
            this._bodyPart.x = this._screenWidth - this._bodyPart.width - this._bodyPart.width/3;
            this._bodyPart.y = this._bodyPart.height/2;
        } else if(this._config.scaleX == -1 && this._config.character == "gameplayJambe") {
            this._bodyPart.x = this._screenWidth/2 - this._bodyPart.width/4;
            this._bodyPart.y = this._bodyPart.height/2;
        } else if(this._config.scaleX == 1 && this._config.character == "gameplayJambe") {
            this._bodyPart.x = this._screenWidth/2 - this._bodyPart.width/2;        
            this._bodyPart.y = this._bodyPart.height/2;
            
        } */
    };

}


export interface ILevelConfig {

    character: string;
    scaleX: number;
    speed: number;
    framesCount: number;
    progressClickStep: number;
    progressTapStep: number;

}